import { TextInput } from 'lego-on-react';
import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/AliceSkillForm';

import { FormChangeHandler } from '../../hocs/types';
import { wrapInText } from '../../lib/i18n-utils';
import { routes } from '../../lib/routes';
import { AliceSkillFormSettings } from '../../types';
import { DevPreviewBanner } from '../DocumentationPage/DevPreviewBanner';
import Description from '../Form/Description/Description';
import { Field, Header } from '../Form/Form';
import Link from '../Link/Link';

const t = i18n(keyset);

interface Props {
    values: AliceSkillFormSettings;
    onChange: FormChangeHandler<AliceSkillFormSettings>;
    disabled?: boolean;
}

const appMetricaDesctiptionBanner = (
    <Description>
        {wrapInText(
            (s) => <Link to="https://appmetrica.yandex.ru/docs/">{s}</Link>,
            (s) => <Link to={routes.documentation.aliceSkills.appmetrica}>{s}</Link>,
        )(t('app-metrica-description'))}
    </Description>
);

export const AppMetricaSettings: React.FC<Props> = ({ onChange, values, disabled }) => {
    return (
        <>
            <Header
                subtitle={
                    <div style={{ fontSize: '13px' }}>
                        <DevPreviewBanner />
                    </div>
                }
            >
                Настройки AppMetrica
            </Header>
            <Field label={t('label-api-key')} description={appMetricaDesctiptionBanner}>
                <TextInput
                    theme="normal"
                    size="s"
                    text={values.appMetricaApiKey}
                    onChange={onChange('appMetricaApiKey')}
                    disabled={disabled}
                />
            </Field>
        </>
    );
};
